import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { sendGTMEvent } from 'reduxModules/googleTagManager/action';
import { saveLiveLesson, unSaveLiveLesson } from 'reduxModules/live/action';

import { REGULAR_CLASS_SAVE_EPISODE } from 'constants/gtmEvent';

export default function useSaveLesson(
  {
    id,
    ordinalNumber,
    learningProgress,
    liveTopicId,
    liveTopicName,
    name,
    section,
    startAt,
    status,
    watchEnabled,
  },
  initialSaveState = false,
) {
  const [isSaved, setIsSaved] = useState(initialSaveState);

  const [interacted, setInteracted] = useState(false);
  const dispatch = useDispatch();

  const toggleSaveState = () => {
    setIsSaved(prev => !prev);
    setInteracted(true);
  };

  useEffect(() => {
    if (!interacted) return;
    if (isSaved) {
      dispatch(saveLiveLesson(id));
      dispatch(
        sendGTMEvent({
          eventName: REGULAR_CLASS_SAVE_EPISODE,
          data: {
            topicId: liveTopicId,
            topicName: liveTopicName,
            liveTime: startAt,
            episodeId: id,
            episodeName: name,
            episodeStatus: status,
            section,
            itemIndex: ordinalNumber,
            watchable: watchEnabled,
            watchProgress: learningProgress,
          },
        }),
      );
    } else {
      dispatch(unSaveLiveLesson(id));
    }
  }, [
    dispatch,
    id,
    ordinalNumber,
    interacted,
    isSaved,
    learningProgress,
    liveTopicId,
    liveTopicName,
    name,
    section,
    startAt,
    status,
    watchEnabled,
  ]);

  return { toggleSaveState, lessonIsSaved: isSaved };
}
